export function parseZips(text) {
  if (!text || typeof text !== 'string') return []
  return text
    .split(',')
    .map(t => t.trim().replace(/\s+/g, ' '))
    .filter(t => t.length > 0)
}
